/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */

/* React Boostrap */
import Footer from "../components/main/Footer"

/* Components */
import { Topbar } from "../components/organisms/Topbar"
import { initPdiComponent } from "../core/service/BusinessLogicService"

/* Utils */
import { isPdiRetailTenant, loc } from "../core/utils"
import React, { Component } from "react"
import { Button, Col, Container, Row } from "react-bootstrap"

class FailPage extends Component {
  state = {}

  componentDidMount() {
    initPdiComponent("FailPage")
  }

  render() {
    let title = this.props.history?.location?.state?.title || "Internal error"
    let message =
      this.props.history?.location?.state?.message ||
      this.props?.message ||
      "The server has encountered an error, and couldn't treat your request."
    console.log(`Fail Page rendered : title = ${title} & message = ${message}`)
    let displayedTitle = loc(title)
    let displayedMessage = loc(message)
    return (
      <Container fluid>
        <Row noGutters>
          <Col className="misc-block">
            <Row>
              {this.props?.tunnelData && (
                <Topbar tunnelData={this.props?.tunnelData} displayToggleButton={false} history={this.props?.history} />
              )}

              <Col sm={12}>
                {/* CONTENT */}
                <Container>
                  <Row className="justify-content-center">
                    <Col xs={11} sm={10} md={7} lg={6} className="hard-shadow-white-block text-center misc-mono-block">
                      <span className="ico-danger-background">
                        <i className="far fa-times"></i>
                      </span>
                      <h1>{displayedTitle}</h1>
                      <p>{displayedMessage}</p>
                      {this.props?.tunnelData && (
                        <Button
                          href={
                            isPdiRetailTenant(this.props.tunnelData?.tenant)
                              ? `${this.props?.tunnelData?.pdiRetailUrl}home`
                              : this.props?.tunnelData?.shopUrl
                          }
                          variant="primary"
                          className="ico-back-small-before"
                        >
                          {loc`Back to shop`}
                        </Button>
                      )}
                    </Col>
                  </Row>
                </Container>
                {/* END CONTENT */}
              </Col>
              {this.props?.tunnelData && (
                <Col sm={12}>
                  <Container>
                    <Footer tunnelData={this.props.tunnelData} />
                  </Container>
                </Col>
              )}
            </Row>
          </Col>
        </Row>
      </Container>
    )
  }
}

export default FailPage
